import { GetTopQuestionsQuery } from '@/api/sanity/generated';
import { FixedLengthArray } from '@/types/fixedLengthArray';
import { LinkQuestionProps } from '../LinkQuestion';
import { getAllCategoriesSlugs } from './getAllQuestionSlugs';

export async function prepareTopQuestions(questions: GetTopQuestionsQuery) {
	if (!questions?.allFaqQuestion) {
		return null;
	}

	const { categoriesSlugs } = await getAllCategoriesSlugs();

	return questions?.allFaqQuestion
		.filter((item) => item && item.description && item.slug)
		.map((item) => {
			const categorySlug = categoriesSlugs.find((category) =>
				category.questions?.some((q) => q?.slug?.current === item?.slug?.current)
			);

			if (!categorySlug?.slug?.current) {
				return null;
			}

			return {
				title: item?.name ?? '',
				categorySlug: categorySlug.slug.current,
				slug: item?.slug?.current ?? '',
			};
		})
		.filter(Boolean) as unknown as FixedLengthArray<
		LinkQuestionProps & {
			categorySlug: string;
		},
		3
	>; // definitely not the safest, but limit is ensured by the query
}
